import React from 'react';

import { Outlet } from 'react-router-dom';

import CommandSearch from '@components/commandSearch/CommandSearch';
import { AccountProvider } from '@contexts/AccountProvider';
import { OperatorSessionProvider } from '@contexts/OperatorSeesionProvider';
// This component initialises the contexts needed for an account

const AccountContextRoute = () => {
    return (
        <AccountProvider>
            <CommandSearch>
                <OperatorSessionProvider>
                    <Outlet />
                </OperatorSessionProvider>
            </CommandSearch>
        </AccountProvider>
    );
};

export default AccountContextRoute;
